import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces/details-paginated-request'
import { getCustomerLastProducts } from '../../customers'

export function useCustomerLastProducts(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(
    ['customerLastProducts', query],
    () => getCustomerLastProducts(query)
  )
  return { data, error, isLoading }
}
